module.exports = __webpack_public_path__ + "static/media/chevron-down-gray.b2a5009b.svg";